NtechApp.ResumeForm = function($view) {
    var me = this;

    this._$view = null;
    this._click = null;

    this._tipsForm = null;

    this._experienceFormNav = null;
    this._experienceFormDateField = null;

    this._referencesFormNav = null;

    this._educationFormNav = null;
    this._educationFormDateField = null;

    this._certificationFormNav = null;
    this._languagesFormNav = null;

    this._formSaver = null;
    this._resumeSettingsForm = null;

    this._construct = function() {
        me._$view = $view;
        me._click = new NtechApp.TouchClickEvent();

        var $formView = me._$view.find("[data-saveManagerForm]");
        me._formSaver = new NtechApp.FormSaver(
            $formView,
            $formView.attr("data-saveManagerForm"),
            $formView.attr("data-saveManagerFormRedirect"),
            false,
            function(redirectCb) {
                me._resumeSettingsForm.loadForm(function() {
                    redirectCb();
                });
            }
        );
        me._formSaver.setOnError(function(errors) {
            NtechApp.formSaveManager.showCollectionErrors.call(me, me._formSaver, errors, "resume");
        });

        me._tipsForm = new NtechApp.ResumeTipsForm(me._$view);

        me._experienceFormNav = new NtechApp.ResumeFormNav(
            me._$view.find("[data-multipleFormNav='experience']")
        );
        me._experienceFormDateField = new NtechApp.ResumeDateField(
            me._$view.find("[data-multipleFormNav='experience']")
        );

        me._referencesFormNav = new NtechApp.ResumeFormNav(
            me._$view.find("[data-multipleFormNav='references']")
        );

        me._educationFormNav = new NtechApp.ResumeFormNav(
            me._$view.find("[data-multipleFormNav='education']")
        );
        me._educationFormDateField = new NtechApp.ResumeDateField(
            me._$view.find("[data-multipleFormNav='education']")
        );

        me._certificationFormNav = new NtechApp.ResumeFormNav(
            me._$view.find("[data-multipleFormNav='certification']")
        );
        me._languagesFormNav = new NtechApp.ResumeFormNav(
            me._$view.find("[data-multipleFormNav='languages']")
        );

        me._resumeSettingsForm = new NtechApp.ResumeSettingsForm();

        me._bindEvents();

        me._setInitialFormStates();
        me._updateSubmitVisibility();
    }

    this._bindEvents = function() {
        $(me._experienceFormNav).on(NtechApp.ResumeFormNav.EVENT_FORM_ADD, function(e, $form) {
            me._experienceFormDateField.bindFormDateFields($form);
        });

        $(me._educationFormNav).on(NtechApp.ResumeFormNav.EVENT_FORM_ADD, function(e, $form) {
            me._educationFormDateField.bindFormDateFields($form);
        });

        me._click.listen(me._$view, "[data-triggerSwitchTo]", function(e) {
            var $trigger = $(e.target).closest("[data-triggerSwitchTo]");
            var target = $trigger.attr("data-triggerSwitchTo");

            if(NtechApp.dom.hasAttribute($trigger.get(0), "data-triggerSwitchToSub")) {
                var subtarget = $trigger.attr("data-triggerSwitchToSub");
                NtechApp.formManager.switchToForm(target, subtarget);
            }
            else
                NtechApp.formManager.switchToForm(target);

            NtechApp.scrollToPx(0);
        });

        $(NtechApp.formManager).on(NtechApp.FormManager.EVENT_FORM_SWITCH, function() {
            me._updateSubmitVisibility();
        });
    }

    this._unbindEvents = function() {
        ;
    }

    this.destruct = function() {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.proto(NtechApp.ResumeForm, {
    _setInitialFormStates: function() {
        var me = this;

        var action = me._$view.attr("data-action");
        if(action == "new") {
            me._$view.find("[data-switchSubTarget='education']").find("[data-addNewTrigger]").trigger("click");
            me._$view.find("[data-switchSubTarget='languages']").find("[data-addNewTrigger]").trigger("click");
        }
    },

    _updateSubmitVisibility: function() {
        var me = this;
        var isNew = (this._$view.attr("data-action") == "new");
        if(!isNew)
            return;

        var $selectedTab = null;
        var $selectedSubtab = null;

        $.each(me._$view.find("[data-switchTo]"), function() {
            if($(this).hasClass("selected"))
                $selectedTab = $(this);
        });
        var $selectedItem = me._$view.find("[data-switchTarget='" + $selectedTab.attr("data-switchTo") + "']");

        $.each($selectedItem.find("[data-switchToSub]"), function() {
            if($(this).hasClass("selected"))
                $selectedSubtab = $(this);
        });

        var $submit = me._$view.find("input[type=submit]").closest(".field");
        if($selectedTab.attr("data-switchTo") == "education" &&
            $selectedSubtab.attr("data-switchToSub") == "languages")
            $submit.css("display", "block");
        else
            $submit.css("display", "none");
    }
});